const updateSites = {
  toastr: 'Site atualizado',
  toastr1: ' foi atualizado com sucesso`',
  toastrError: 'Site já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default updateSites;
